
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Trash2 } from "lucide-react";

interface DeleteNotificationButtonProps {
  onDelete: () => void;
  isLoading?: boolean;
  isArchived?: boolean;
}

const DeleteNotificationButton = ({ 
  onDelete, 
  isLoading,
  isArchived 
}: DeleteNotificationButtonProps) => {
  return (
    <Button 
      type="button" 
      variant="destructive" 
      onClick={onDelete}
      disabled={isLoading}
    >
      {isLoading ? (
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
      ) : (
        <Trash2 className="h-4 w-4 mr-2" />
      )}
      Verwijderen
    </Button>
  );
};

export default DeleteNotificationButton;
